import React from 'react'
import PropTypes from 'prop-types'
import Layout from '@layouts/Layout'
import { useIntl } from 'gatsby-plugin-intl'
import { Section1 } from '@templates/support'
import Jumbotron from '@components/jumbotron/Jumbotron'
import { faHeadset } from '@fortawesome/free-solid-svg-icons'

const Support = props => {
  const { formatMessage } = useIntl()
  const { pageContext } = props
  const { languageName } = pageContext

  return <Layout languageName={languageName} pageContext={pageContext}>
    <Jumbotron
      icon={faHeadset}
      title={formatMessage({ id: 'menu-support' })}
      description={formatMessage({ id: 'menu-support-content' })}
    />
    <div className='row'>
      <Section1 className='col-md-12'>
          Support
      </Section1>
    </div>
  </Layout>
}

Support.propTypes = {
  pageContext: PropTypes.any
}

export default Support
